import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
// Router
import router from './router'
// Vuetify
import vuetify from './plugins/vuetify'
// Vue Toast
import Toasted from 'vue-toasted'

Vue.config.productionTip = false
Vue.use(Toasted, {
  iconPack: 'mdi',
  singleton: true,
  className: 'p-5'
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
